import React from 'react'

const MySvgIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
      fill='none'
      version='1.1'
      width='20'
      height='20'
      viewBox='0 0 20 20'
    >
      <defs>
        <clipPath id='master_svg0_70_5893'>
          <rect x='0' y='0' width='20' height='20' rx='0' />
        </clipPath>
      </defs>
      <g clipPath='url(#master_svg0_70_5893)'>
        <g>
          <path
            d='M6.16835,7.33997L9.4135,16.5494C9.44169,16.6295,9.5173,16.683,9.60213,16.683L10.41951,16.683C10.50143,16.683,10.57507,16.633,10.60535,16.5569L14.2742,7.332520000000001C14.3425,7.16079,14.5873,7.165649999999999,14.6487,7.33996L17.894,16.5494C17.9222,16.6295,17.9978,16.683,18.0826,16.683L18.7174,16.683C18.8554,16.683,18.9519,16.546599999999998,18.906,16.4165L14.7054,4.505672C14.6439,4.331384,14.3992,4.32657,14.3309,4.498307L10.22862,14.8173C10.16033,14.9891,9.91552,14.9842,9.85413,14.8098L6.22474,4.503207C6.16335,4.32888,5.91861,4.323962,5.85027,4.495682L1.109027,16.409C1.0567628,16.540300000000002,1.153508,16.683,1.2948520000000001,16.683L1.939063,16.683C2.0209900000000003,16.683,2.09463,16.633,2.1249000000000002,16.5569L5.79388,7.332520000000001C5.86219,7.16079,6.10693,7.16566,6.16835,7.33997'
            fill='#333333'
            fillOpacity='1'
            style={{ mixBlendMode: 'passthrough' }}
          />
          <path
            d='M1.939063,17.183Q2.41398,17.183,2.5895,16.7417L5.96272,8.26089L8.94192,16.715600000000002Q9.10661,17.183,9.60213,17.183L10.41951,17.183Q10.89442,17.183,11.0699,16.7417L14.4431,8.26088L17.4224,16.715600000000002Q17.5871,17.183,18.0826,17.183L18.7174,17.183Q19.0796,17.183,19.2888,16.8873Q19.498,16.5917,19.3775,16.2502L15.1769,4.339374Q15.0156,3.881867,14.5305,3.872327Q14.0455,3.862787,13.8663,4.313594L10.05979,13.88852L6.69635,4.337132Q6.53521,3.879524,6.05016,3.869778Q5.5651,3.860031,5.38571,4.310797L0.644466,16.2241Q0.507271,16.5689,0.7155469999999999,16.8759Q0.9238238,17.183,1.2948520000000001,17.183L1.939063,17.183ZM5.36274,7.07289Q5.55072,6.69777,5.99364,6.706580000000001Q6.43005,6.71526,6.60434,7.08653L6.01892,5.42409L5.36274,7.07289ZM9.42496,15.0775L9.8145,16.183L10.21597,16.183L10.64386,15.1072Q10.45358,15.4517,10.02884,15.4433Q9.60081,15.4347,9.42496,15.0775ZM13.8533,7.05317Q14.0429,6.698,14.474,6.70657Q14.9141,6.71532,15.0876,7.0928L14.5,5.42653L13.8533,7.05317Z'
            fillRule='evenodd'
            fill='#333333'
            fillOpacity='1'
          />
        </g>
      </g>
    </svg>
  )
}

export default MySvgIcon
